import * as React from 'react';
import type { GetServerSidePropsResult, NextPage } from 'next';

import Image from 'next/image';
import { Recipe } from '@src/firebase/types';
import { Header } from '@src/routes/all/components/Header/Header';
import { ViewRecipeList } from '@src/routes/recipes/components/ViewRecipeList/';
import { getPublishedRecipes } from '@src/routes/recipes/firestore/get-published-recipes';

interface ViewRecipesProps {
  recipes: Recipe[];
}

const ViewRecipes: NextPage<ViewRecipesProps> = (props) => {
  const { recipes } = props;

  return (
    <div>
      <div className="bg-white">
        {/* Mobile menu TODO gavalas */}

        {/* Hero section */}
        <div className="relative bg-gray-900">
          {/* Decorative image and overlay */}
          <div aria-hidden="true" className="absolute inset-0 overflow-hidden">
            <Image
              src="/images/limes.jpg"
              className="w-full h-full object-center object-cover"
              layout="fill"
            />
            {/* <img
          src="https://tailwindui.com/img/ecommerce-images/home-page-01-hero-full-width.jpg"
          alt=""
          className="w-full h-full object-center object-cover"
        /> */}
          </div>
          <div
            aria-hidden="true"
            className="absolute inset-0 bg-gray-900 opacity-50"
          />

          {/* Navigation */}
          <Header />

          <div className="relative max-w-3xl mx-auto py-32 px-6 flex flex-col items-center text-center sm:py-64 lg:px-0">
            <h1 className="text-4xl font-extrabold tracking-tight text-white lg:text-6xl">
              Recipes
            </h1>
            <p className="mt-4 text-xl text-white">
              All of our recipes in one place!
            </p>
          </div>
        </div>
      </div>
      <div className="min-h-full">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div>
            <ViewRecipeList recipes={recipes} />
          </div>
        </div>
      </div>
    </div>
  );
};

export async function getServerSideProps(): Promise<
  GetServerSidePropsResult<ViewRecipesProps>
> {
  return {
    props: {
      recipes: await getPublishedRecipes(),
    },
  };
}

export default ViewRecipes;
